<template>
  <v-dialog
    v-model="isVisibleDialog"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-text>
        <div
          v-if="showGeofence"
          class="d-flex justify-end"
        >
          <v-btn
            color="primary"
            class="mx-0 mb-1"
            small
            @click="setMapView(isGeofenceFocus)"
          >
            {{ isGeofenceFocus ? "Focus on Point" : "Focus on Geofence" }}
          </v-btn>
        </div>
        <l-map
          v-if="showMap && checkMap"
          class="map"
          :zoom="zoom"
          :center="point"
          :options="mapOptions"
          style="height: 400px"
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />
          <l-marker :lat-lng="point" />
        </l-map>
        <GmapMap
          v-else-if="showMap"
          ref="gmap"
          class="map"
          :center="gMapPoints"
          :zoom="zoom"
        >
          <GmapMarker :position="gMapPoints" />

          <template v-if="showGeofence">
            <!-- Render Circle -->
            <GmapCircle
              v-if="geofence.geofence_type == 'circle'"
              :ref="'circleGeofence_'"
              :key="geofence?.id"
              :center="geofence.center_point"
              :radius="geofence.radius"
              :options="circleOptions"
            />
            <!-- Render Polygons -->
            <GmapPolygon
              v-if="geofence.geofence_type == 'polygon'"
              :ref="'polygonGeofence_'"
              :key="geofence?.id"
              :paths="geofence.polygon"
              :editable="false"
              :draggable="false"
              :options="polygonOptions"
            />
          </template>
        </GmapMap>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="toggleModal()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  props: {
    isVisibleDialog: {
      type: Boolean,
      required: true,
    },
    toggleModal: {
      type: Function,
      default: () => {},
    },
    position: {
      type: Object,
      default: () => ({
        lat: 24.87847,
        lng: 67.0645625,
      }),
    },
    showGeofence: {
      type: Boolean,
      default: () => false,
    },
    geofence: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showMap: false,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      mapOptions: {
        zoomSnap: 0.5,
      },
      circleOptions: {
        fillColor: "#20a390",
        fillOpacity: 0.3,
        strokeColor: "#20a390",
        strokeWeight: 2,
        clickable: false,
        editable: false,
        zIndex: 1,
      },
      polygonOptions: {
        fillColor: "#20a390",
        fillOpacity: 0.3,
        strokeColor: "#20a390",
        strokeWeight: 2,
        clickable: false,
        editable: false,
        draggable: false,
        geodesic: true,
        zIndex: 1,
      },

      //
      isGeofenceFocus: false,
    };
  },
  computed: {
    checkMap() {
      return process.env.VUE_APP_GOOGLE_MAP_KEY ? false : true;
    },
    point() {
      return latLng(this.position.lat, this.position.lng);
    },
    gMapPoints() {
      return {
        lat: parseFloat(this.position.lat),
        lng: parseFloat(this.position.lng),
      };
    },
  },
  mounted() {
    setTimeout(() => {
      this.showMap = true;
      // setTimeout(() => {
      //   if (this.geofence?.id) {
      //     this.setGeoFenceBound();
      //   }
      // }, 300);
    }, 100);
  },
  methods: {
    setMapBound() {
      this.$refs.gmap.$mapPromise.then((map) => {
        const p = { ...this.position };
        const { lat, lng } = p;
        const bounds = new window.google.maps.LatLngBounds();
        const pnt = [{ lat: parseFloat(lat), lng: parseFloat(lng) }];
        // const pnt = [this.position];
        pnt.forEach((v) => {
          bounds.extend(new window.google.maps.LatLng(v.lat, v.lng));
        });
        map.fitBounds(bounds);
      });
    },
    setMapView(v) {
      if (!v) {
        this.setGeoFenceBound();
      } else {
        this.setMapBound();
      }
      this.isGeofenceFocus = !v;
    },
    setGeoFenceBound() {
      this.$refs.gmap.$mapPromise.then((map) => {
        const val = this.geofence;
        if (val.geofence_type === "polygon") {
          const bounds = new window.google.maps.LatLngBounds();

          val.polygon.forEach((v) => {
            bounds.extend(new window.google.maps.LatLng(v.lat, v.lng));
          });
          map.fitBounds(bounds);
        } else if (val.geofence_type === "circle") {
          const center = new window.google.maps.LatLng(
            val.center_point.lat,
            val.center_point.lng
          );
          const radius = val.radius; // radius in meters

          const bounds = new window.google.maps.LatLngBounds();

          // Use 4 cardinal points to expand the bounds
          [0, 90, 180, 270].forEach((heading) => {
            const point = window.google.maps.geometry.spherical.computeOffset(
              center,
              radius,
              heading
            );
            bounds.extend(point);
          });

          map.fitBounds(bounds);
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.map
  width: 100%
  height: 400px
</style>
